import config from "config/appConfig";

import type { PaginationTokenType } from "shared/types";
import type { WaiverSignatureModel } from "shared/types/Waiver";
import type { IStateProps } from "utils/StateOf";
import createStore from "utils/createStore";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.WAIVERS_DATA}`;

export interface Values {
	loading: boolean;

	waiverSignatures: WaiverSignatureModel[];
	nextToken: PaginationTokenType;
	previousToken: PaginationTokenType;

	submitting: boolean;
}

export const initialState: IStateProps<Values> = {
	loading: false,

	waiverSignatures: [],
	nextToken: null,
	previousToken: null,

	submitting: false
};

export default createStore<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
